/* "Get the pair" (James 2026-10-02): adds both cushions of a Left/Right diptych in one go,
   skipping any half already in the basket, through the same multi-add the drawer's "Add all"
   uses (window.BokjaCartAddMany, assets/bokja-wishlist-add.js), which fires the theme's
   CartAddEvent so the drawer re-renders and opens. Nothing to add = just open the drawer. */
(function () {
  if (window.__bokjaPairBound) return;
  window.__bokjaPairBound = true;
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest && e.target.closest('[data-bokja-pair-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var ids = (btn.dataset.variants || '').split(',').filter(Boolean).map(Number);
    btn.disabled = true;
    try {
      var cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      var inCart = cart.items.map(function (i) { return i.variant_id; });
      var missing = ids.filter(function (id) { return inCart.indexOf(id) === -1; });
      if (missing.length && window.BokjaCartAddMany) {
        await window.BokjaCartAddMany(missing.map(String), btn);
      } else {
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && drawer.open) drawer.open();
      }
    } catch (err) {
      console.error('bokja-pair', err);
    } finally {
      btn.disabled = false;
    }
  });
})();
